// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"ZoomImage_backdrop__rE1BD","container":"ZoomImage_container__9RQ0t","image":"ZoomImage_image__07iid","zoomLink":"ZoomImage_zoomLink__NO5mF"};